import React from 'react';
import { ProfilePointsWidget } from './widget';

export const ProfilePointsPage: React.FC = () => <ProfilePointsWidget />;
